




































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import {
  BaseDocument,
  JinroRoomDocument,
  JinroPlayerStatisticsDocument,
  JinroPlayerDocument,
} from "@/services/datatypes";

@Component
export default class JinroStatisticsTable extends Vue {
  @Prop() readonly playerStatistics!: Array<JinroPlayerStatisticsDocument>;
  @Prop() readonly selectedPlayerId!: string;
  @Prop() readonly timeLastGameEnded!: firebase.firestore.Timestamp;
  radioButton = "count";

  columns = [
    { field: "displayName", label: "名前" },
    {
      field: "jinroGameCount",
      label: "参戦数",
      sortable: true,
      numeric: true,
    },
    {
      field: "murabitoTeamWinCount",
      label: "村人勢(勝数)",
      sortable: true,
      numeric: true,
      visible: true,
    },
    {
      field: "jinroTeamWinCount",
      label: "人狼勢(勝数)",
      sortable: true,
      numeric: true,
      visible: true,
    },
    {
      field: "murabitoTeamWinRatio",
      label: "村人勢(勝率)",
      numeric: true,
      visible: false,
    },
    {
      field: "jinroTeamWinRatio",
      label: "人狼勢(勝率)",
      numeric: true,
      visible: false,
    },
  ];

  @Watch("radioButton")
  onChange() {
    const murabitoWinCount = this.columns[2];
    const jinroWinCount = this.columns[3];
    const murabitoWinRatio = this.columns[4];
    const jinroWinRatio = this.columns[5];
    if (this.radioButton === "count") {
      murabitoWinCount.visible = true;
      jinroWinCount.visible = true;
      murabitoWinRatio.visible = false;
      jinroWinRatio.visible = false;
    }
    if (this.radioButton === "ratio") {
      murabitoWinRatio.visible = true;
      jinroWinRatio.visible = true;
      murabitoWinCount.visible = false;
      jinroWinCount.visible = false;
    }
  }

  get playerStatisticsRatioAdded(): Array<JinroPlayerStatisticsDocument> {
    if (!this.playerStatistics || this.playerStatistics.length === 0) {
      return [];
    }
    const ps = this.playerStatistics.map((ps) => {
      const mbtwc = ps.murabitoTeamWinCount ? ps.murabitoTeamWinCount : 0;
      const mbtlc = ps.murabitoTeamLoseCount ? ps.murabitoTeamLoseCount : 0;
      const jrtwc = ps.jinroTeamWinCount ? ps.jinroTeamWinCount : 0;
      const jrtlc = ps.jinroTeamLoseCount ? ps.jinroTeamLoseCount : 0;

      const mtwr = mbtwc / (mbtlc + mbtwc);
      const jtwr = jrtwc / (jrtlc + jrtwc);
      const murabitoTeamWinRatio = mtwr ? Math.round(mtwr * 100) + "%" : "-";
      const jinroTeamWinRatio = jtwr ? Math.round(jtwr * 100) + "%" : "-";

      return {
        murabitoTeamWinRatio: murabitoTeamWinRatio,
        jinroTeamWinRatio: jinroTeamWinRatio,
        ...ps,
      };
    });
    return ps;
  }

  get selected(): JinroPlayerStatisticsDocument | null {
    if (!this.selectedPlayerId) {
      return null;
    }
    const player = this.playerStatisticsRatioAdded.find((player) => {
      return player.playerId === this.selectedPlayerId;
    });
    if (!player) {
      return null;
    }

    return player;
  }

  get lastGameEndedTime(): string {
    if (!this.timeLastGameEnded) {
      return "";
    }
    return this.timeLastGameEnded.toDate().toLocaleString();
  }
}
